'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Crosshair } from '@/components/atoms/Icons';
import { useExplore } from './ExploreProvider';
import { LocationOutOfRegionModal } from './LocationOutOfRegionModal';
export function LocationFinder(t0) {
  const $ = _c(29);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    userLocation,
    locationPermission,
    requestUserLocation,
    centerOnUserLocation,
    clearLocationDismissal
  } = useExplore();
  const [isRequesting, setIsRequesting] = useState(false);
  const [showOutOfRegionModal, setShowOutOfRegionModal] = useState(false);
  let t2;
  if ($[0] !== centerOnUserLocation || $[1] !== clearLocationDismissal || $[2] !== locationPermission || $[3] !== requestUserLocation || $[4] !== userLocation) {
    t2 = async () => {
      if (locationPermission === "granted" && userLocation) {
        const centered = centerOnUserLocation();
        if (!centered) {
          setShowOutOfRegionModal(true);
        }
        return;
      }
      if (typeof window !== "undefined") {
        localStorage.removeItem("locationModalDismissed");
      }
      clearLocationDismissal?.();
      setIsRequesting(true);
      const result = await requestUserLocation();
      setIsRequesting(false);
      if (result && result.success && !result.inRegion) {
        setShowOutOfRegionModal(true);
      }
    };
    $[0] = centerOnUserLocation;
    $[1] = clearLocationDismissal;
    $[2] = locationPermission;
    $[3] = requestUserLocation;
    $[4] = userLocation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleLocationRequest = t2;
  let t3;
  if ($[6] !== locationPermission || $[7] !== userLocation) {
    t3 = () => {
      if (locationPermission === "granted" && userLocation) {
        return <svg className="w-5 h-5 text-[#A8A8A8]" fill="currentColor" viewBox="0 0 24 24"><path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z" /></svg>;
      }
      return <span className="relative"><span className="absolute m-auto w-[2px] left-0 top-0 right-0 h-6.5 bottom-0 bg-[#A8A8A8] rotate-[135deg] z-10 border-l-[1px] border-white" /><Crosshair className="relative" /></span>;
    };
    $[6] = locationPermission;
    $[7] = userLocation;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const getLocationIcon = t3;
  let t4;
  if ($[9] !== locationPermission || $[10] !== userLocation) {
    t4 = () => {
      if (locationPermission === "granted" && userLocation) {
        return "Show My Location";
      }
      if (locationPermission === "denied" || locationPermission === "dismissed") {
        return "Enable Location";
      }
      return "Find My Location";
    };
    $[9] = locationPermission;
    $[10] = userLocation;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const getButtonText = t4;
  const t5 = `flex items-center justify-between p-3 bg-white lg:border lg:border-[#dddddd] rounded-[10px] lg:shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#00EAFD] lg:min-w-[170px] xl:min-w-[197px] ${locationPermission === "granted" && userLocation ? "" : isRequesting ? "text-gray-400 cursor-wait" : "text-gray-700"} ${className}`;
  const t6 = getButtonText();
  const t7 = getButtonText();
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className=" hidden lg:block ml-2 text-[#757575] text-[16px] font-[500]">Use My Location</span>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== getLocationIcon || $[14] !== isRequesting) {
    t9 = isRequesting ? <svg className="w-5 h-5 text-gray-400 animate-spin" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg> : getLocationIcon();
    $[13] = getLocationIcon;
    $[14] = isRequesting;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleLocationRequest || $[17] !== isRequesting || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t9) {
    t10 = <button onClick={handleLocationRequest} disabled={isRequesting} className={t5} title={t6} aria-label={t7}>{t8}{t9}</button>;
    $[16] = handleLocationRequest;
    $[17] = isRequesting;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setShowOutOfRegionModal(false);
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== showOutOfRegionModal) {
    t12 = <LocationOutOfRegionModal isOpen={showOutOfRegionModal} onClose={t11} />;
    $[24] = showOutOfRegionModal;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12) {
    t13 = <>{t10}{t12}</>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}

// Location status component for more detailed display
export function LocationStatus() {
  const $ = _c(6);
  const {
    userLocation,
    locationPermission
  } = useExplore();
  if (locationPermission === "denied") {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="flex items-center space-x-2 text-sm text-red-600"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg><span>Location access denied</span></div>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (locationPermission === "granted" && userLocation) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z" /></svg>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== userLocation.accuracy) {
      t1 = userLocation.accuracy && ` (${Math.round(userLocation.accuracy)}m accuracy)`;
      $[2] = userLocation.accuracy;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t1) {
      t2 = <div className="flex items-center space-x-2 text-sm text-[#00EAFD]">{t0}<span>Location active{t1}</span></div>;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  return null;
}